<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
      </div>
      <div id="iframe" class="container">
      </div>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { GetReportDataRange } from "@/api";
export default {
  mixins: [GetDataMixin],
  data () {
    return {
      chart: () => import(`@/views/${this.route.desc}`)
    };
  },
  watch: {
    // $route: function (o, n) {
    //   this.getRoute()
    // }
  },
  methods: {
    getUrl () {
      GetReportDataRange({
        type:0,
        userId:this.userInfo.id,
        modelCode:this.route.name
      }).then(res=>{
       let iframeDiv = document.getElementById('iframe')
      if (this.route.type == 4) {
        var url = this.system_setting.reportServerHost + '/jmreport/view/' + this.route.desc + '?token=null&userId=' + this.userInfo.id + '&deptId=' + this.userInfo.deptId + '&moduleId=' + this.route.id +'&range='+res.returnData.str
      }
      else if (this.route.type == 5) {
        var url = this.system_setting.runQianReportServerHost + this.route.desc + '&userId=' + this.userInfo.id + '&deptId=' + this.userInfo.deptId + '&moduleId=' + this.route.id +'&range='+res.returnData.str
      }
      console.log(url, this.route)
      iframeDiv.innerHTML = '<iframe style="width: 100%;border: none;min-height: calc(100vh - 170px);" src=\'' + url + '\'></iframe>';
      })

      
    }
  },
  mounted () {
    this.getUrl()
  },
};
</script>

<style lang="scss" scoped>
.a {
  background-image: url("../../../assets/dp.png");
  width: 100%;
  height: calc(100vh - 140px);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
